import React from "react";
import "./CV.css";
// import shihab_resume from "../../assests/resume/shihab_resume.pdf";
// import { Download } from "lucide-react";

function CV() {
  return (
    // <a
    //   href={shihab_resume}
    //   className="cv-btn"
    //   rel="noopener noreferrer"
    //   download
    // >
    //   <Download size={15} /> <b className="resume"> resume</b>
    // </a>

    <a
      href="https://docs.google.com/document/d/1NzNMMnYhF9DDOWuInnX2tldNAWGVQ6jI/edit#heading=h.7qx0s83zwvhx"
      target="_blank"
      rel="noopener noreferrer"
      className="cv-btn"
    >
      Resume
    </a>
  );
}

export default CV;
